import type { AppProductFamily, AppProductGroup, AppProductVariant } from '#types/AppTypes'

export type EntryType = 'group' | 'family' | 'variant'

export type EntryTypeId = `${EntryType}.${string}`

export type ProductEntry = AppProductGroup | AppProductFamily | AppProductVariant

export function isProductGroup(entry: ProductEntry | undefined): entry is AppProductGroup {
  return entry ? Object.hasOwn(entry, 'families') : false
}

export function isProductFamily(entry: ProductEntry | undefined): entry is AppProductFamily {
  return entry ? Object.hasOwn(entry, 'variants') : false
}

export function isProductVariant(entry: ProductEntry | undefined): entry is AppProductVariant {
  return entry ? Object.hasOwn(entry, 'parentFamily') : false
}

export function getType(entry: ProductEntry): EntryType {
  if (isProductGroup(entry)) {
    return 'group'
  }
  if (isProductFamily(entry)) {
    return 'family'
  }
  if (isProductVariant(entry)) {
    return 'variant'
  }
  throw new Error('Unknown entry type')
}

export function getTypeId(entry: ProductEntry): EntryTypeId {
  return `${getType(entry)}.${entry.id}`
}
